import { ErpFieldSourceEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/erp-field-source.enum";

export const REFERENCE_TYPE_LABELS = {
  [ErpFieldSourceEnum.DOCUMENT]: "DOCUMENT",
  [ErpFieldSourceEnum.REFERENCE]: "REFERENCE",
  [ErpFieldSourceEnum.INVOICE_REFERENCE]: "INVOICE REFERENCE",
  [ErpFieldSourceEnum.ACCOUNTING_REFERENCE]: "ACCOUNTING REFERENCE"
};